export const SUPPORTED_LOCALES = ['en', 'de', 'en-GB', 'es-ES', 'fr', 'it', 'pt-PT'];
